<template>
    <div>
        <div class="card-bind">
            <van-nav-bar title="实名信息绑定" @click-left="onClickLeft" left-text="返回" left-arrow></van-nav-bar>
            <div class="page-content">

                <fieldset class="md-field">
                    <div class="md-field-content">
                        <img src="../assets/images/scaniccid.png">
                        <div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content"><label class="md-field-item-title">卡板编号</label>
                                <div class="md-field-item-control">
                                    <input v-model="iccid" max="20" name="iccid" placeholder="以8986开头的数字或短号" maxlength="" autocomplete="off"
                                           type="text" class="md-input-item-input">
                                </div>
                            </div>
                        </div>
                        <div class="md-field-item-children" v-if="errMsg">
                            <div class="md-input-item-msg">
                                <p>{{errMsg}}</p>
                            </div>
                        </div>
                    </div>
                    <template v-if="cardCheckOK==true && needAuth == 1 && binded==false">
                    <!--<div class="md-field-item md-input-item is-solid is-browser left normal">
                        <div class="md-field-item-content">
                            <label class="md-field-item-title">所在区域</label>
                            <div class="md-field-item-control">
                                <input name="input-item-41288218" placeholder="查询中..."
                                                                      readonly="readonly" maxlength=""
                                                                      autocomplete="off" type="text"
                                                                      class="md-input-item-input">
                            </div>
                        </div>

                    </div>-->
                    <div class="md-field-item md-input-item is-solid is-browser is-clear left normal">
                        <div class="md-field-item-content">
                            <label class="md-field-item-title">联系电话</label>
                            <div class="md-field-item-control">
                                <input v-model="ruleForm.mobile" name="mobile" placeholder="您本人的手机号" maxlength=""
                                                                      autocomplete="off" type="tel"
                                                                      class="md-input-item-input">
                            </div>
                            <div class="md-field-item-right">
                                <div class="md-input-item-clear" style="display: none;">
                                    <i class="md-icon icon-font md-icon-clear clear md"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div class="md-field-item md-input-item is-solid is-browser is-clear left normal">
                            <div class="md-field-item-content">
                                <label class="md-field-item-title">本人姓名</label>
                                <div class="md-field-item-control">
                                    <input  v-model="ruleForm.name" name="name" placeholder="您本人姓名" maxlength=""
                                           autocomplete="off" type="text"
                                           class="md-input-item-input">
                                </div>
                                <div class="md-field-item-right">
                                    <div class="md-input-item-clear" style="display: none;">
                                        <i class="md-icon icon-font md-icon-clear clear md"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md-field-item md-input-item is-solid is-browser is-clear left normal">
                            <div class="md-field-item-content">
                                <label class="md-field-item-title">身份证号</label>
                                <div class="md-field-item-control">
                                    <input  v-model="ruleForm.idcard" name="name" placeholder="您的身份证号码" maxlength=""
                                            autocomplete="off" type="text"
                                            class="md-input-item-input">
                                </div>
                                <div class="md-field-item-right">
                                    <div class="md-input-item-clear" style="display: none;">
                                        <i class="md-icon icon-font md-icon-clear clear md"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div class="md-field-item md-input-item is-solid is-browser left normal">
                        <div class="md-field-item-content">
                            <label class="md-field-item-title">验证码</label>
                            <div class="md-field-item-control">
                                <input name="mobile" placeholder="短信验证码" v-model="ruleForm.code" maxlength="6" autocomplete="off" type="tel" class="md-input-item-input">
                            </div>
                            <div class="md-field-item-right">
                                <div class="input-operator" @click="handleSms">
                                    {{smsBtnTxt}}
                                </div>
                            </div>
                        </div>
                    </div>
                    </template>
                    <template v-else-if="binded==true && needAuth ==1 ">
                        <!--<div class="md-field-item md-input-item is-solid is-browser left normal">
                            <div class="md-field-item-content">
                                <label class="md-field-item-title">所在区域</label>
                                <div class="md-field-item-control">
                                    <input name="input-item-41288218" placeholder="查询中..."
                                                                          readonly="readonly" maxlength=""
                                                                          autocomplete="off" type="text"
                                                                          class="md-input-item-input">
                                </div>
                            </div>

                        </div>-->
                        <div class="md-field-item md-input-item is-solid is-browser is-clear left normal">
                            <div class="md-field-item-content">
                                <label class="md-field-item-title">联系电话</label>
                                <div class="md-field-item-control">
                                    <input v-model="bindInfo.mobile" disabled name="mobile" placeholder="您本人的手机号" maxlength=""
                                           autocomplete="off" type="tel"
                                           class="md-input-item-input">
                                </div>
                                <div class="md-field-item-right">
                                    <div class="md-input-item-clear" style="display: none;">
                                        <i class="md-icon icon-font md-icon-clear clear md"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="md-field-item md-input-item is-solid is-browser is-clear left normal">
                            <div class="md-field-item-content">
                                <label class="md-field-item-title">本人姓名</label>
                                <div class="md-field-item-control">
                                    <input  v-model="bindInfo.username" name="name" disabled placeholder="您本人姓名" maxlength=""
                                            autocomplete="off" type="text"
                                            class="md-input-item-input">
                                </div>
                                <div class="md-field-item-right">
                                    <div class="md-input-item-clear" style="display: none;">
                                        <i class="md-icon icon-font md-icon-clear clear md"></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="md-field-item md-input-item is-solid is-browser is-clear left normal">
                            <div class="md-field-item-content">
                                <div class="md-field-item-children">
                                    <div class="md-input-item-msg">
                                        <p>以上是该卡的实名信息，请核对是否正确</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <footer class="md-field-footer" v-else-if="wxReady" @click="handleScan">
                        <div class="scan">
                            <img src="../assets/images/scan.png" >
                            <div style="margin: 0px 0.1rem;">扫描条形码识别</div>
                        </div>
                    </footer>
                </fieldset>
                <fieldset class="md-field">
                    <div class="md-field-content">
                        <button @click="handleCheckCard" v-if="cardCheckOK==false" type="button" class="md-button primary active block" :class="{'active':cardLengthCheck,'inactive':!cardLengthCheck}">
                            <div class="md-button-inner">
                                <div class="md-button-content" ><span>查询</span></div>
                            </div>
                        </button>
                        <button v-else-if="binded==false" type="button"  @click="handleBindCard" class="md-button primary active block">
                            <div class="md-button-inner">
                                <div class="md-button-content"><span>提交绑定</span></div>
                            </div>
                        </button>
                        <button v-else-if="binded==true" type="button"  @click="handleQueryCard" class="md-button primary active block">
                            <div class="md-button-inner">
                                <div class="md-button-content"><span>确认</span></div>
                            </div>
                        </button>
                    </div> </fieldset>
            </div>
        </div>
        <div  class="warm-tips">
            <h5 >温馨提示</h5>
            <ol>
                <li>卡板编号在手机小卡的背面，以8986开头的19位数字或20位（不包含尾部的字母），您可扫描条形码识别</li>
                <li>请仔细核对卡号</li>
                <!--<li>联系电话必须为<span>本人持有的手机号码</span>，并且不能是虚拟运营商的号码</li>
                <li>将上网卡与微信用户绑定并进行实名认证，绑定成功后可以进行流量查询、产品订购等其它服务</li>-->
            </ol>
        </div>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "bind",
        data() {
            return {
                iccid: '',
                cardLengthCheck:false,
                errMsg: false,
                cardCheckOK:false,
                wxReady:false,
                sms:false,
                binded:false,
                bindInfo:{},
                needAuth:0,
                smsBtnTxt:'发送验证码',
                ruleForm:{
                    iccid:'',
                    mobile:'',
                    name:'',
                    code:''
                }
            };
        },
        watch:{
            iccid(iccid){
                this.iccid = iccid.toUpperCase();
                this.cardCheckOK = false;
                if(this.iccid.indexOf('C') !== -1){
                    //移动卡二十位
                    if(this.iccid.length == 20 || (this.iccid.length >= 6 && this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }else{
                    if(this.iccid.length == 19  || (this.iccid.length >= 6 || this.iccid.length <= 10)){
                        this.cardLengthCheck = true
                    }else{
                        this.cardLengthCheck = false
                    }
                }
            }
        },
        methods: {
            handleCheckCard(){
                this.errMsg = '';
                this.cardCheckOK = false;
                this.binded = false;
                this.$toast.loading('查询中');
                this.fetchData('/card/queryCard',{iccid:this.iccid},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.cardCheckOK = true
                        this.needAuth = res.data.needAuth
                        if(this.needAuth == 0) {
                            this.$router.push({name: 'index'})
                        }else if(res.data.mobile){
                            this.binded = true
                            this.bindInfo = res.data
                        }
                    }else{
                        this.errMsg = res.msg
                    }
                })
            },
            handleQueryCard(){
                this.$router.push({name:'index',query:{iccid:this.iccid}})
            },
            handleBindCard(){
                this.$toast.loading('绑定中')
                this.ruleForm.iccid = this.iccid
                this.fetchDataPost('/card/bind',this.ruleForm,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg);
                        this.$router.push({name:'index'})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            this.wxReady = true;
                        })
                    }
                })
            },
            handleScan(){
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success:(res)=>{
                        if(res.resultStr.includes(',')){
                            this.iccid = res.resultStr.split(',')[1];
                        }else {
                            this.iccid = res.resultStr;
                        }

                    }
                })
            },
            handleSms(){
                if(this.sms == false) {
                    this.sms = true
                    this.$toast.loading()
                    this.fetchData('/sms/send', {mobile: this.ruleForm.mobile}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success('发送成功')
                            let s = 60;
                            let intval = setInterval(()=>{
                                this.smsBtnTxt = s+'秒重发'
                                if(s <= 0){
                                    this.smsBtnTxt = '发送验证码';
                                    this.sms = false;
                                    clearInterval(intval);
                                }
                                s--;
                            },1000)

                        } else {
                            this.sms = false;
                            this.$toast.fail('发送失败')
                        }
                    })
                }
            }
        },
        created: function () {
            this.initWechatJs()
            if(this.$route.query.cardno){
                this.iccid = this.$route.query.cardno
                this.handleCheckCard()
            }
        }
    };
</script>
<style>
    .md-field-item {
        position: relative;
        border-bottom: 1px solid #f3f3f3;
    }

    .md-field-item-right {
        position: relative;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        margin-left: .12rem;
        display: -webkit-inline-box;
        display: -webkit-inline-flex;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        color: #858b9c;
        font-size: .28rem;
    }

    .card-bind .input-operator {
        color: #75b2f9;
    }

    .md-input-item.is-error .md-field-item-content:before {
        content: "";
        position: absolute;
        z-index: 2;
        -webkit-transform-origin: 100% 50%;
        transform-origin: 100% 50%;
        -webkit-transform: scaleY(.5) translateY(100%);
        transform: scaleY(.5) translateY(100%);
        bottom: 0;
        left: 0;
        right: auto;
        top: auto;
        width: 100%;
        border-bottom: .04rem solid #ff5257;
        -webkit-transform-origin: 50% 100%;
        transform-origin: 50% 100%;
    }

    .md-field-item-content:before {
        content: "";
        position: absolute;
        z-index: 2;
        -webkit-transform-origin: 100% 50%;
        transform-origin: 100% 50%;
        -webkit-transform: scaleY(.5) translateY(100%);
        transform: scaleY(.5) translateY(100%);
        bottom: 0;
        left: 0;
        right: auto;
        top: auto;
        width: 100%;
        border-bottom: .02rem solid #e2e4ea;
        -webkit-transform-origin: 50% 100%;
        transform-origin: 50% 100%;
    }

    .md-field-item-children {
        font-size: .24rem;
        margin-top: .2rem;
    }

    .md-input-item-msg {
        font-size: .24rem;
        color: #ff5257;
    }

    .md-input-item-brief, .md-input-item-msg {
        word-break: break-all;
        word-wrap: break-word;
    }

    .md-button {
        display: block;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.36rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        text-align: center;
        box-sizing: border-box;
        -webkit-appearance: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0.04rem;
        outline: 0px;
        transition: all 0.3s ease 0s;
        overflow: visible;
        position: relative;
    }


    .md-button.primary {
        background: #2f86f6;
        color: #fff;
    }

    .md-button.block {
        width: 100%;
    }

    .md-button.inactive {
        opacity: .3;
    }

    .md-button-inner {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        word-wrap: break-word;
        white-space: nowrap;
    }

    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #c3c3c3;
    }

    ::-moz-placeholder { /* Firefox 19+ */
        color: #c3c3c3;
    }

    :-ms-input-placeholder { /* IE 10+ */
        color: #c3c3c3;
    }

    :-moz-placeholder { /* Firefox 18- */
        color: #c3c3c3;
    }

    .md-button-content {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        padding: 0 .06rem;
    }

    .md-field-item-content {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        min-height: 1rem;
        box-sizing: border-box;
    }

    .page-content {
        padding-bottom: .1rem;
        min-height: 6rem;
        border-radius: 0 0 .2rem .2rem;
        background: #fff;
    }

    .card-bind {
        background: #fff;
        font-size: .12rem;
        margin: .2rem auto;
        -webkit-box-shadow: 0 0 1px #dedede;
        box-shadow: 0 0 1px #dedede;
        border-radius: .1rem;
    }

    .md-field {
        padding: .1rem .2rem;
        border: none;
    }

    .md-field-item-title {
        text-align: left;
        width: 1.6rem;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        font-size: .32rem;
    }

    .md-field-item-control {
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
    }

    .md-field-item.is-solid .md-field-item-title {
        width: 1.6rem;
    }

    .md-field-item-title {
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        margin-right: .1rem;
        font-size: .32rem;
    }

    .md-field-item-control {
        text-align: left;
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
        padding: 0;
        margin: 0;
        line-height: 1.15;
        border: none;
        background: none;
        outline: none;
        border: 0;
    }

    .card-bind .page-title {
        margin: .3rem 0 0 0;
        font-size: .3rem;
        height: .8rem;
        line-height: .8rem;
        border-radius: .2rem .2rem 0 0;
        border-bottom: 1px solid #fafafa;
        color: #888;
        text-align: center;
    }

    .md-input-item-input {
        width: 100%;
        height: 1rem;
        color: rgb(17, 26, 52);
        font-size: 0.32rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        line-height: 1;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        -webkit-appearance: none;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        background: 0px 0px;
        outline: 0px;
        border: none;
    }

    .md-field-item-control {
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
    }

    .md-field-footer {
        margin-top: .2rem;
    }
    .card-bind .scan img{
        width: .36rem;
        height: .36rem;
        margin-top: .08rem;
    }
    .card-bind .scan {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        font-size: .36rem;
        color: #3c6bff;
    }
    .md-icon.icon-font {
        font-size: .16rem;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        letter-spacing: 0;
        speak: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>



// WEBPACK FOOTER //
// src/pages/bind.vue